import React, { Component, useState, useEffect } from "react";
import styled from "styled-components";
import HeaderDas from "../components/core/headerDas";
import { CaredashboardList } from "../pages";
import SideNav from "../components/sideNav";
import { Ptag } from "../components/core/fonts";
import { useNavigate } from "react-router-dom";
import SideNavContent from "../components/sideNavContent";

const CareDashboard = (props) => {
  const [planEditable, setPlanEditable] = useState(false);
  const [showBuffer, setShowBuffer] = useState(false);
  const [showClaim, setShowClaim] = useState(false)
  const [dashboardCta, setDashboardCta] = useState({});
  const [company_name, setCompanyName] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/v1")
    window.scrollTo(0, 0);
    localStorage.setItem("company_name", company_name);
  }, [company_name]);

  // const company_name = localStorage.getItem("company_name")

  const setPlanEditableFlag = (editable) => {
    setPlanEditable(editable);
  };

  return (
    <HomeWrapper>
      {/* <Sidebar planEditable={planEditable} /> */}
      <SideNav>
        <SideNavContent
          planEditable={planEditable}
          showCB={showBuffer}
          showCS = {showClaim}
          dashboardCtaData={dashboardCta}
        />
      </SideNav>
      <HeaderDas company_name={company_name} />
      <CaredashboardList
        setCompanyName={setCompanyName}
        setPlanEditable={setPlanEditableFlag}
        navigate={navigate}
        showBuffer={setShowBuffer}
        showClaims={setShowClaim}
        dashboardCta={setDashboardCta}
      />
    </HomeWrapper>
  );
};
// class careDashboard extends Component {
// 	constructor(props){
// 		super(props)
// 		this.state =
// 		{
// 			company_name:'',
// 			planEditable: false
// 		}
// 	}

//     async componentDidMount(){

// 		c

// 		await this.setState({company_name:company_name})

//     }

// 	onClickEditEmployees = () => {
// 		localStorage.setItem("is_edit", true)
//         this.props.history.push("/uploadexcel");
// 	}

//     render() {
//         return (

//         )
//     }
// }

export default CareDashboard;

const HomeWrapper = styled.div`
  width: 100%;
  background: #ccc;
`;

const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 80px;
`;

const Tab = styled.a`
  cursor: pointer;
  padding: 20px 0;

  &:hover {
    background: #4a4a4a30;
  }
`;
